export default __webpack_public_path__ + "static/tag-dont-3-light-233730b1301ffe11be9066648a96e27434ac480b338cc4a3266fd4dba45ce235.png";